exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".plaid-selector-wrapper .loading-overlay{height:calc(100% + 20px);width:calc(100% + 20px);position:absolute;z-index:1;left:-10px;top:-10px;border-radius:5px;background-color:rgba(0,0,0,.3);pointer-events:none}.plaid-selector-wrapper .loading-overlay .message{height:100%;display:flex;justify-content:center;align-items:center}.plaid-selector-wrapper .disabled-content{z-index:-1}", ""]);

// exports
